<bz-table uniqueId="bringoz-timeline-logs"
          appBringozIdGenerator="timeline-logs-table"
          [items]="timeline() ?? []"
          [rowHeight]="60"
          [resizable]="false">
  <ng-template bzTableHeader>
    <div class="th col-time">
      {{ 'Time' | translate }}
      <bz-icon class="timeline-logs-sort-icon" [icon]="sortIcon"></bz-icon>
    </div>
    <div class="th col-event">{{ 'Event' | translate }}</div>
    <div class="th col-user">{{ 'User' | translate }}</div>
    <div class="th col-source">{{ 'Source' | translate }}</div>
  </ng-template>

  <ng-template bzTableRow let-log>
    <app-bringoz-timeline-logs-table-row appBringozIdGenerator="timeline-logs-table-row" [log]="log"></app-bringoz-timeline-logs-table-row>
  </ng-template>

  <bz-empty-state bzTableEmptyState
                  [title]="'No Timeline Found' | translate"
                  image="assets/images/empty_state/empty_state_dispatching.png">
  </bz-empty-state>
</bz-table>
